import Script from "next/script"
import { MOCK_ALL_APIS } from "@/constants"
import { useCourseStore } from "@/store/courseStoreProvider"

export interface Props {}

export function CaptchaLoader({}: Props) {
  const { CAPTCHA_SITE_KEY } = useCourseStore((state) => state.envVars)

  if (MOCK_ALL_APIS) {
    return (
      <div className="h-[60px] w-[70px] bg-surface drop-shadow fixed bottom-[14px] right-0 grid place-items-center">
        <div className="text-[10px] text-text-subtle text-center font-semibold leading-none relative">
          <div className="size-8 border-8 border-[#1a73e8] rounded-full -translate-y-1" />
          <div className="absolute -bottom-2.5 text-center -left-2 opacity-75">Recaptcha</div>
        </div>
      </div>
    )
  }

  if (!CAPTCHA_SITE_KEY) throw new Error("CAPTCHA Failed to load")

  return (
    <Script
      src={`https://www.google.com/recaptcha/api.js?render=${CAPTCHA_SITE_KEY}`}
      key="grecaptcha"
    />
  )
}
